













import { Settings, Features } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class ReEnableCache extends Vue {
  @Getter("settings/activeCacheSettings") settings!: Settings;
  @Getter("settings/activeCacheFeatures") features!: Features;

  title = "Re-enable Cache";

  isSaving = false;

  reEnableCache() {
    this.$ga.button(this.title);
    this.title = "Enabling";
    this.isSaving = true;

    this.$store.dispatch("reEnableCache").then(() => {
      this.title = "Enabled!";
      this.isSaving = false;
      setTimeout(() => {
        this.title = "Re-enable Cache";
      }, 1000);
    });
  }
}
